import { render } from "./VersionList.vue?vue&type=template&id=0db967d1&scoped=true"
import script from "./VersionList.vue?vue&type=script&lang=js"
export * from "./VersionList.vue?vue&type=script&lang=js"

import "./VersionList.vue?vue&type=style&index=0&id=0db967d1&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0db967d1"

export default script